
export const sFechaPublicacion = '2026-10-02T10:48:57.5568921-06:00';
export const sVersion = 'vf1.1.610021048';
            